import Vue from 'vue';
import Vuex from 'vuex';

import { layout } from './layout.module';
import { alert } from './alert.module';
import { account } from './account.module';
import { art } from './art.module';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    layout,
    alert,
    account,
    art,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js